import { defineEvent } from '../types/event';
export var GIFT_MESSAGE_PROMPT_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Gift_Message_Prompt_Click'
        }
    ]
});
